const OBJECT_PATH_PREFIX = '/object/';

export function toPortableObjectPath(value) {
  const source = String(value || '').trim();
  if (!source || source.startsWith(OBJECT_PATH_PREFIX)) {
    return source;
  }
  try {
    const url = new URL(source);
    if ((url.protocol === 'http:' || url.protocol === 'https:') && url.pathname.startsWith(OBJECT_PATH_PREFIX)) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch (error) {
    return source;
  }
  return source;
}
